import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import DokterLayout from '../DokterLayout';
import axiosInstance from '../../../api/axios';

const STATUS_CFG = {
  pending:    { label: 'Menunggu',       color: '#B45309', bg: '#FEF3C7' },
  confirmed:  { label: 'Dikonfirmasi',   color: '#1D4ED8', bg: '#DBEAFE' },
  checked_in: { label: 'Sedang Periksa', color: '#6D28D9', bg: '#EDE9FE' },
  completed:  { label: 'Selesai',        color: '#065F46', bg: '#D1FAE5' },
  cancelled:  { label: 'Dibatalkan',     color: '#991B1B', bg: '#FEE2E2' },
};

export default function Antrian() {
  const [queue,   setQueue]   = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter,  setFilter]  = useState('all');
  const [dateFilter, setDateFilter] = useState('');
  const navigate              = useNavigate();
  const location              = useLocation();

  useEffect(() => { 
    fetchQueue(); 
  }, [location.key]);

  const fetchQueue = async () => {
    setLoading(true);
    try {
      const res  = await axiosInstance.get('/dokter/antrian');
      const data = res.data?.data ?? res.data ?? [];
      setQueue(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error('Error fetching queue:', err);
      setQueue([]);
    } finally {
      setLoading(false);
    }
  };

  const updateStatus = async (id, status) => {
    try {
      await axiosInstance.put(`/dokter/antrian/${id}`, { status });
      fetchQueue();
    } catch (err) {
      console.error('Error updating status:', err);
    }
  };

  const fmt = (t) =>
    t ? new Date(t).toLocaleDateString('id-ID', { day: '2-digit', month: 'long', year: 'numeric' }) : '-';

  const getLocalDateString = (dateInput) => {
    if (!dateInput) return '';
    const d = new Date(dateInput);
    if (isNaN(d.getTime())) return '';
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const baseQueueForCounts = dateFilter 
    ? queue.filter((q) => getLocalDateString(q.tanggal_pendaftaran) === dateFilter)
    : queue;

  const counts = {
    all:        baseQueueForCounts.length,
    pending:    baseQueueForCounts.filter((q) => q.status?.toLowerCase().trim() === 'pending').length,
    checked_in: baseQueueForCounts.filter((q) => q.status?.toLowerCase().trim() === 'checked_in').length,
    completed:  baseQueueForCounts.filter((q) => q.status?.toLowerCase().trim() === 'completed').length,
    cancelled:  baseQueueForCounts.filter((q) => q.status?.toLowerCase().trim() === 'cancelled').length,
  };

  const filtered = queue.filter((q) => {
    const matchStatus = filter === 'all' || q.status?.toLowerCase().trim() === filter.toLowerCase().trim();
    const matchDate = !dateFilter || getLocalDateString(q.tanggal_pendaftaran) === dateFilter;
    return matchStatus && matchDate;
  });

  return (
    <DokterLayout title="Antrian Pasien">
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&display=swap');
        .ant-wrap * { font-family: 'DM Sans', sans-serif; box-sizing: border-box; }

        /* 🟢 BARU: Kontainer Atas Baris Tunggal */
        .ant-header-row {
          display: flex; justify-content: space-between; align-items: center;
          gap: 16px; margin-bottom: 24px;
        }

        /* 🟢 BARU: Input Tanggal yang Lebih Ringkas & Elegan */
        .ant-date-box {
          display: flex; align-items: center; gap: 8px; background: #fff;
          border: 1.5px solid #E5E7EB; border-radius: 10px; padding: 10px 14px;
          height: 48px; box-shadow: 0 1px 2px rgba(0,0,0,0.02); transition: border-color .15s;
        }
        .ant-date-box:focus-within { border-color: #6366F1; }
        .ant-date-box input {
          border: none; outline: none; font-size: 14px; font-weight: 500;
          color: #374151; font-family: inherit; cursor: pointer; background: transparent;
        }
        .ant-date-clear {
          background: none; border: none; color: #9CA3AF; cursor: pointer;
          font-size: 11px; font-weight: bold; padding: 2px 4px; border-radius: 50%;
        }
        .ant-date-clear:hover { color: #EF4444; background: #FEF2F2; }

        .ant-stats { display: flex; gap: 10px; flex-grow: 1; }
        .ant-stat {
          flex: 1; background: #fff; border: 1.5px solid #E5E7EB; border-radius: 12px;
          padding: 10px 16px; cursor: pointer; transition: all .15s;
          display: flex; flex-direction: column; justify-content: center; min-height: 58px;
        }
        .ant-stat:hover  { border-color: #6366F1; }
        .ant-stat.active { border-color: #6366F1; background: #F5F3FF; }
        .ant-stat .lbl   { font-size: 11px; font-weight: 600; color: #9CA3AF; text-transform: uppercase; letter-spacing: .5px; }
        .ant-stat .num   { font-size: 22px; font-weight: 700; color: #111827; margin-top: 1px; }

        .ant-list { display: flex; flex-direction: column; gap: 10px; }
        .ant-card {
          background: #fff; border: 1.5px solid #E5E7EB; border-radius: 14px;
          padding: 18px 22px; display: grid; grid-template-columns: 52px 1fr auto;
          gap: 16px; align-items: center; transition: box-shadow .15s;
        }
        .ant-card:hover { box-shadow: 0 4px 16px rgba(0,0,0,.07); }

        .ant-num {
          width: 52px; height: 52px; border-radius: 12px; flex-shrink: 0;
          background: #F3F4F6; display: flex; align-items: center;
          justify-content: center; font-size: 15px; font-weight: 800; color: #374151;
        }

        .ant-info h3    { margin: 0 0 2px; font-size: 16px; font-weight: 700; color: #111827; }
        .ant-info .meta { display: flex; flex-wrap: wrap; gap: 10px; font-size: 13px; color: #6B7280; margin-top: 4px; }
        .ant-info .kelu {
          margin-top: 7px; display: inline-block;
          background: #F9FAFB; border: 1px solid #E5E7EB;
          border-radius: 6px; padding: 3px 10px; font-size: 12px; color: #374151;
        }

        .ant-right { display: flex; flex-direction: column; align-items: flex-end; gap: 8px; flex-shrink: 0; }
        .s-badge {
          display: inline-flex; align-items: center; gap: 5px;
          padding: 4px 11px; border-radius: 20px; font-size: 12px; font-weight: 700;
        }
        .s-dot { width: 6px; height: 6px; border-radius: 50%; }

        .ant-acts { display: flex; gap: 7px; flex-wrap: wrap; justify-content: flex-end; }
        .btn {
          padding: 8px 15px; border-radius: 8px; font-size: 13px; font-weight: 600;
          cursor: pointer; border: none; transition: all .15s; font-family: inherit;
        }
        .btn-violet { background: #6366F1; color: #fff; }
        .btn-violet:hover { background: #4F46E5; }
        .btn-green  { background: #10B981; color: #fff; }
        .btn-green:hover  { background: #059669; }
        .btn-red    { background: #fff; color: #EF4444; border: 1.5px solid #FCA5A5; }
        .btn-red:hover    { background: #FEF2F2; }
        .btn-outline{ background: #fff; color: #6366F1; border: 1.5px solid #C7D2FE; }
        .btn-outline:hover{ background: #EEF2FF; }

        .ant-empty { text-align: center; padding: 60px 20px; color: #9CA3AF; font-size: 14px; }

        @media (max-width: 900px) {
          .ant-header-row { flex-direction: column; align-items: stretch; gap: 12px; }
          .ant-stats { grid-template-columns: repeat(2,1fr); display: grid; }
          .ant-date-box { justify-content: space-between; }
        }
        @media (max-width: 640px) {
          .ant-card  { grid-template-columns: 1fr; }
          .ant-right { align-items: flex-start; }
        }
      `}</style>

      <div className="ant-wrap">
        {/* 🟢 HEADER ROW: Menyatukan Tab Counts & Filter Tanggal secara Horizontal */}
        <div className="ant-header-row">
          <div className="ant-stats">
            {[
              { key: 'all',        label: 'Total'          },
              { key: 'pending',    label: 'Menunggu'       },
              { key: 'checked_in', label: 'Sedang Periksa' },
              { key: 'completed',  label: 'Selesai'        },
              { key: 'cancelled',  label: 'Dibatalkan'     },
            ].map(({ key, label }) => (
              <div key={key} className={`ant-stat ${filter === key ? 'active' : ''}`} onClick={() => setFilter(key)}>
                <div className="lbl">{label}</div>
                <div className="num">{counts[key] ?? 0}</div>
              </div>
            ))}
          </div>

          {/* Input Tanggal diletakkan di sebelah kanan Tab Stats */}
          <div className="ant-date-box">
            <span style={{ fontSize: '15px', color: '#6B7280', userSelect: 'none' }}>📅</span>
            <input 
              type="date" 
              value={dateFilter} 
              onChange={(e) => setDateFilter(e.target.value)} 
            />
            {dateFilter && (
              <button className="ant-date-clear" onClick={() => setDateFilter('')} title="Reset Tanggal">
                ✕
              </button>
            )}
          </div>
        </div>

        {/* Info label tanggal aktif (hanya muncul saat tanggal dipilih) */}
        {dateFilter && (
          <div style={{ fontSize: '13px', fontWeight: '600', color: '#6366F1', marginBottom: '14px', background: '#EEF2FF', display: 'inline-block', padding: '4px 12px', borderRadius: '6px' }}>
            Filter Aktif: {fmt(dateFilter)}
          </div>
        )}

        {loading ? (
          <p style={{ color: '#9CA3AF', padding: '40px 0', textAlign: 'center' }}>Memuat antrian…</p>
        ) : (
          <div className="ant-list">
            {filtered.length === 0 ? (
              <div className="ant-empty">
                <p>Tidak ada antrian yang cocok dengan filter ini.</p>
              </div>
            ) : filtered.map((item) => {
              const currentStatus = item.status?.toLowerCase().trim() ?? 'pending';
              const sc = STATUS_CFG[currentStatus] ?? STATUS_CFG.pending;

              return (
                <div key={item.id} className="ant-card">
                  <div className="ant-num">{item.no_antrian?.split('-').pop() ?? '#'}</div>

                  <div className="ant-info">
                    <h3>{item.pasien?.nama ?? '-'}</h3>
                    <div className="meta">
                      <span>{fmt(item.tanggal_pendaftaran)}</span>
                      <span>{item.estimasi_jam_kehadiran ?? item.jam_kunjungan?.substring(0, 5) ?? '-'}</span>
                      <span>{item.no_antrian ?? '-'}</span>
                    </div>
                    <span className="kelu">Keluhan: {item.keluhan ?? '-'}</span>
                  </div>

                  <div className="ant-right">
                    <span className="s-badge" style={{ background: sc.bg, color: sc.color }}>
                      <span className="s-dot" style={{ background: sc.color }} />
                      {sc.label}
                    </span>
                    <div className="ant-acts">
                      {currentStatus === 'pending' && (
                        <button className="btn btn-violet" onClick={() => updateStatus(item.id, 'checked_in')}>
                          Mulai Pemeriksaan
                        </button>
                      )}
                      {currentStatus === 'checked_in' && (
                        <button className="btn btn-green" onClick={() => navigate(`/dokter/rekam-medis/${item.id}`)}>
                          Input Rekam Medis
                        </button>
                      )}
                      {currentStatus === 'completed' && (
                        <button className="btn btn-outline" onClick={() => navigate(`/dokter/rekam-medis/${item.id}`)}>
                          Lihat Rekam Medis
                        </button>
                      )}
                      {['pending', 'confirmed'].includes(currentStatus) && (
                        <button className="btn btn-red" onClick={() => updateStatus(item.id, 'cancelled')}>
                          Batalkan
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </DokterLayout>
  );
}